import React from 'react';

const Datenschutz = () => {
  return (
    <div className="page-container">
      <section className="page-hero">
        <div className="section-container">
          <h1 className="page-title">Datenschutzerklärung</h1>
        </div>
      </section>

      <section className="page-content">
        <div className="section-container">
          <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            <h2 className="subsection-title">Verantwortlicher</h2>
            <p className="text-content">
              Physiotherapie Grau<br />
              Rosestraße 4<br />
              99510 Apolda<br />
              Telefon: 03644 515313<br />
              E-Mail: physio.grau@gmail.com
            </p>

            <h2 className="subsection-title">Erhebung und Verarbeitung personenbezogener Daten</h2>
            <p className="text-content">
              Wir erheben und verarbeiten personenbezogene Daten nur, wenn Sie uns diese 
              freiwillig über das Kontaktformular oder per E-Mail übermitteln.
            </p>

            <h2 className="subsection-title">Zweck der Datenverarbeitung</h2>
            <p className="text-content">
              Die Verarbeitung Ihrer Daten erfolgt ausschließlich zur Bearbeitung Ihrer Anfrage 
              und zur Kontaktaufnahme mit Ihnen.
            </p>

            <h2 className="subsection-title">Weitergabe an Dritte</h2>
            <p className="text-content">
              Ihre Daten werden nicht an Dritte weitergegeben.
            </p>

            <h2 className="subsection-title">Verwendung zu Werbezwecken</h2>
            <p className="text-content">
              Ihre Daten werden nicht zu Werbezwecken verwendet.
            </p>

            <h2 className="subsection-title">Tracking und Analyse</h2>
            <p className="text-content">
              Wir verwenden keine Tracking-Tools, keine Analyse-Software und keine Cookies zu 
              Marketingzwecken.
            </p>

            <h2 className="subsection-title">Speicherdauer</h2>
            <p className="text-content">
              Ihre Daten werden nur so lange gespeichert, wie es für die Bearbeitung Ihrer 
              Anfrage erforderlich ist. Nach Abschluss der Bearbeitung werden Ihre Daten gelöscht, 
              sofern keine gesetzlichen Aufbewahrungspflichten bestehen.
            </p>

            <h2 className="subsection-title">Ihre Rechte gemäß DSGVO</h2>
            <p className="text-content">
              Sie haben das Recht auf:
            </p>
            <ul className="content-list">
              <li>Auskunft über die von uns verarbeiteten personenbezogenen Daten</li>
              <li>Berichtigung unrichtiger Daten</li>
              <li>Löschung Ihrer bei uns gespeicherten Daten</li>
              <li>Einschränkung der Datenverarbeitung</li>
              <li>Datenübertragbarkeit</li>
              <li>Widerruf Ihrer Einwilligung zur Datenverarbeitung</li>
            </ul>

            <p className="text-content">
              Zur Ausübung Ihrer Rechte wenden Sie sich bitte per E-Mail an: 
              physio.grau@gmail.com
            </p>

            <h2 className="subsection-title">Beschwerderecht</h2>
            <p className="text-content">
              Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die 
              Verarbeitung Ihrer personenbezogenen Daten durch uns zu beschweren.
            </p>

            <h2 className="subsection-title">Kontaktformular</h2>
            <p className="text-content">
              Wenn Sie uns über das Kontaktformular eine Anfrage zukommen lassen, werden die 
              von Ihnen angegebenen Daten (Name, E-Mail-Adresse, Telefonnummer, Nachricht) 
              ausschließlich zur Bearbeitung Ihrer Anfrage verwendet. Die Daten werden an die 
              E-Mail-Adresse physio.grau@gmail.com gesendet und dort verarbeitet.
            </p>
            <p className="text-content">
              Es erfolgt keine Speicherung in externen Systemen und keine Weiterleitung an 
              Dritte.
            </p>

            <h2 className="subsection-title">E-Mail-Kontakt</h2>
            <p className="text-content">
              Wenn Sie uns per E-Mail kontaktieren, werden Ihre Angaben zur Bearbeitung der 
              Anfrage gespeichert. Die Daten werden gelöscht, sobald die Bearbeitung 
              abgeschlossen ist und keine gesetzlichen Aufbewahrungsfristen bestehen.
            </p>

            <h2 className="subsection-title">Aktualität der Datenschutzerklärung</h2>
            <p className="text-content">
              Diese Datenschutzerklärung ist aktuell gültig. Durch die Weiterentwicklung 
              unserer Website kann es erforderlich werden, diese Datenschutzerklärung zu ändern.
            </p>

            <p className="text-content" style={{ marginTop: '3rem', fontSize: '0.875rem', color: '#6C757D' }}>
              Stand: Januar 2025
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Datenschutz;